import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Container,
  CustomInput,
  InputGroup,
  InputGroupAddon, InputGroupText
} from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { service } from "./service";
import logo from "../../assets/img/illustrations/falcon.png";
import logoIco from "../../../src/assets/img/favicons/favico.ico";
import { getconfigData } from "../../layouts/service";
import { useAppDispatch } from "../../store/hooks";
import { setSessionDetails } from "../../store/slices/impersonationSlice";
import leftImage from "../../../src/assets/img/dashboard-png/login-left.jpg";
import { FaBuilding, FaEnvelope, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { startGroupSession, clearGroupSession, NO_GROUPS_MESSAGE } from '../GroupPortal/session';
import { isGroupPortalRole } from '../GroupPortal/roles';
import './Login.css'

let pendingAccountSelection = null;

const accountListStorageKey = (email) => `availableAccounts:${String(email || "").toLowerCase()}`;

const getStoredAccounts = (email) => {
  try {
    const storedAccounts = JSON.parse(sessionStorage.getItem(accountListStorageKey(email)) || "[]");
    return Array.isArray(storedAccounts) ? storedAccounts : [];
  } catch (error) {
    return [];
  }
};

const storeAccounts = (email, accounts) => {
  if (email && Array.isArray(accounts)) {
    sessionStorage.setItem(accountListStorageKey(email), JSON.stringify(accounts));
  }
};

const Login = (props) => {
  const dispatch = useAppDispatch();
  const isChoosingAccount = props.location.pathname === "/switch-account";
  const accountSelectionState = props.location.state || pendingAccountSelection;
  document.querySelectorAll(".navbar-vertical").forEach(function (el) {
    el.style.display = "none";
  });

  document.querySelectorAll(".navbar-glass").forEach(function (el) {
    el.style.display = "none";
  });
  const [values, setValues] = useState({
    email: accountSelectionState?.email || "",
    password: accountSelectionState?.password || "",
  });
  const [result, setResult] = useState({});
  const [resultRoll, setResultRoll] = useState({});
  const [accounts, setAccounts] = useState(
    Array.isArray(accountSelectionState?.accounts)
      ? accountSelectionState.accounts
      : getStoredAccounts(accountSelectionState?.email || localStorage.getItem("user_email"))
  );
  const [isLoadingAccounts, setIsLoadingAccounts] = useState(
    isChoosingAccount && !Array.isArray(accountSelectionState?.accounts) &&
      getStoredAccounts(accountSelectionState?.email || localStorage.getItem("user_email")).length === 0
  );
  const [accountSelectionError, setAccountSelectionError] = useState("");
  const [isSelectingAccount, setIsSelectingAccount] = useState(false);

  useEffect(() => {
    if (isChoosingAccount && pendingAccountSelection) {
      pendingAccountSelection = null;
    }

    if (isChoosingAccount && !accountSelectionState?.accounts) {
      const email = accountSelectionState?.email || localStorage.getItem("user_email") || "";
      const storedAccounts = getStoredAccounts(email);
      setValues((currentValues) => ({
        ...currentValues,
        email: currentValues.email || email,
      }));

      if (storedAccounts.length > 0) {
        setAccounts(storedAccounts);
        setIsLoadingAccounts(false);
        return;
      }

      props.history.replace("/login");
    }
  }, [isChoosingAccount, accountSelectionState, props.history]);

  const [invalidCredentials, setInvalidCredentials] = useState(false);
  const [disabledAccountError, setDisabledAccountError] = useState("");
  const [passwordShown1, setPasswordShown1] = useState(false);
  const [eye1, setEye1] = useState(<FontAwesomeIcon icon={faEye} />);
  const [isEye1, setIsEye1] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisiblity1 = () => {
    setPasswordShown1(passwordShown1 ? false : true);
    setEye1(
      passwordShown1 ? (
        <FontAwesomeIcon icon={faEye} />
      ) : (
        <FontAwesomeIcon icon={faEyeSlash} />
      )
    );
  };
  const hangleChange = (value, name) => {
    handleFocus(name);
    setValues({
      ...values,
      [name]: value,
    });
    if (name == "password") {
      if (value.length > 0) {
        setIsEye1(true);
      } else {
        setIsEye1(false);
      }
    }
  };
  const [focused, setFocused] = useState({ email: false, password: false });

  const handleFocusInput = (field) => {
    setFocused({ ...focused, [field]: true });
  };

  const handleBlur = (field) => {
    setFocused({ ...focused, [field]: false });
  };

  const [errors, setErrors] = useState({});
  const [ismfaEnable, setIsmfaEnable] = useState(false);
  const [forMFA, setForMFA] = useState({
    role_id: null,
    user_id: null,
  });
  const [code, setCode] = useState();
  const [mfaerrorMsg, setMfaerrorMsg] = useState("");

  const handleFocus = (name) => {
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const onCodeChange = (value) => {
    setCode(value);
  };

  const onSubmitCode = async (e) => {
    e.preventDefault();
    if (code && forMFA.role_id && forMFA.user_id) {
      service
        .verifyMFAToken(code, forMFA.user_id, forMFA.role_id)
        .then((response) => {
          if (response.success == true) {
            console.log("response", response);
            
            storeToLocalStorage(response);
            if (response.data.role_id == 7) {
              // localStorage.setItem("superadmin_mfa_verified",true);
            } else {
              let newPublisher = response?.data?.pubid;
              let existingPublishers = [];
              if (localStorage.getItem("existingPublishers")) {
                existingPublishers = localStorage.getItem("existingPublishers");
              }
              else {
                existingPublishers.push(newPublisher);
                localStorage.setItem("existingPublishers", JSON.stringify(existingPublishers))
              }
            }
          } else {
            setMfaerrorMsg(response.message);
            setTimeout(() => {
              setMfaerrorMsg("");
            }, 3000);
          }
        });
    } else if (!code) {
      setMfaerrorMsg("Verification code required");
      setTimeout(() => {
        setMfaerrorMsg("");
      }, 3000);
    }
  };
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
    setFocused({ ...focused, password: true });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (staticValidation() === true) {
      localStorage.setItem("currentChannel", "");
      console.log("validationOk", values);
      service
        .sign_in(values.email, values.password)
        .then(async (result) => {
          console.log(result,"result");
          if (result?.multiple_accounts === true && Array.isArray(result.accounts)) {
            storeAccounts(values.email, result.accounts);
            if (!isChoosingAccount) {
              pendingAccountSelection = {
                accounts: result.accounts,
                email: values.email,
                password: values.password,
              };
              props.history.push("/switch-account");
              return;
            }
            setAccounts(result.accounts);
            setAccountSelectionError("");
            return;
          }

          if (result?.status === 403 && result?.message === "Publisher account is disabled") {
            setDisabledAccountError(result.message);
            setInvalidCredentials(false);
            return;
          }

          setDisabledAccountError("");
          if (!result?.success || !result?.data) {
            setInvalidCredentials(true);
          } else {
            setInvalidCredentials(false);
            await completeSignIn(result);
          }
        })
        .catch((e) => false);
    } else {
      console.log("validationNotOk");
      console.log(errors);
    }
  };

  const completeSignIn = async (result) => {
    if (result?.data?.mfa_enabled == 1) {
      let existingPublishers = localStorage.getItem("existingPublishers");
      if (existingPublishers) {
        const currentPublisher = result?.data?.pubid;
        existingPublishers = JSON.parse(existingPublishers);
        if (existingPublishers && existingPublishers.length > 0 && existingPublishers.includes(currentPublisher)) {
          storeToLocalStorage(result);
          await publisherDetails(currentPublisher);
        }
      } else {
        setIsmfaEnable(true);
        setForMFA({
          forMFA,
          role_id: result.data.role_id,
          user_id: result.data.user_id,
        });
      }
    } else {
      storeToLocalStorage(result);
    }
  };

  const handleAccountSelection = async (account) => {
    if (isSelectingAccount) return;

    setIsSelectingAccount(true);
    setAccountSelectionError("");
    const result = await service.select_account(account, values.password);

    if (!result?.success || !result?.data) {
      setAccountSelectionError(result?.message || "Unable to sign in to the selected account.");
      setIsSelectingAccount(false);
      return;
    }

    await completeSignIn(result);
    setIsSelectingAccount(false);
  };

  const handleBackToCredentials = () => {
    pendingAccountSelection = null;
    setAccounts([]);
    setAccountSelectionError("");
    setInvalidCredentials(false);
    setValues({ email: "", password: "" });
    props.history.replace("/login");
  };

  // const storeToLocalStorage = (data) => {
  //   setTimeout(() => {
  //     console.log("signInData", data.data);
  //     if (data.data.influencer_id) {
  //       localStorage.setItem("influencer_id", data.data.influencer_id);
  //       localStorage.setItem("user_id", data.data.user_id);
  //     }
  //     else{
  //     //         localStorage.setItem("channelConfig", JSON.stringify(data.data.channels));
  //     // localStorage.setItem(
  //     //   "publisherConfig",
  //     //   JSON.stringify(data.data.pub_config)
  //     // );

  //     }
  //     localStorage.setItem("role_id", data.data.role_id);
  //     localStorage.setItem("user_name", data.data.name);
  //     localStorage.setItem("pub_id", data.data.pubid);
  //     localStorage.setItem("currentPublisher", data.data.pubid);
  //     localStorage.setItem("user_email", data.data.email);
  //     localStorage.setItem("isLoged", true);
  //     localStorage.setItem("bucketType", data.data.bucket_type);
  //     data.data.content_partner_id &&
  //       localStorage.setItem("contentPartnerId", data.data.content_partner_id);
  //     !data.data.content_partner_id &&
  //       localStorage.removeItem("contentPartnerId");

  //     if (data.data.advertiser_id) {
  //       localStorage.setItem("advertiser_id", data.data.advertiser_id);
  //     }
  //     if(data?.data?.user_id){
  //       localStorage.setItem("user_id",data.data.user_id)
  //     }
  //     // props.history.replace('/')
  //     window.location.href = "/";
  //   }, 2000);
  // };
  const storeToLocalStorage = (data) => {
    const influencer_id = data?.data?.influencer_id;
    const user_id = data?.data?.user_id;
    const pub_id = data?.data?.pubid;
    const role_id = data?.data?.role_id;
    const name = data?.data?.name;
    const email = data?.data?.email;
    const isLoged = true;
    const bucketType = data?.data?.bucket_type;
    const contentPartnerId = data?.data?.content_partner_id;
    const advertiser_id = data?.data?.advertiser_id;
    const access_token = data?.data?.access_token;
    const pub_user_id = data?.data?.publisher_users_id;
    const timezone = data?.data?.timezone;
    const currency = data?.data?.currency;
    const config = data?.data?.config;
    const routes = data?.data?.routes;
    // Group Owner/Admin logins (roles 22/23) manage one or more groups; groups[0] is the default.
    const isGroupLogin = isGroupPortalRole(role_id);
    const groups = Array.isArray(data?.data?.groups) ? data.data.groups : [];
    if (isGroupLogin && groups.length === 0) {
      clearGroupSession();
      toast.error(NO_GROUPS_MESSAGE);
      return;
    }
    // Call getconfigData API to get config data
    const configDataPromise = getconfigData(pub_id)
      .then((configResponse) => {
        const channels = configResponse?.data?.channels || [];
        const firstChannelId = channels?.[0]?.channel_id || null;
        const pubConfig = configResponse?.data?.pub_config || null;

        localStorage.setItem(
          "channelConfig",
          JSON.stringify(channels)
        );
        let pub_config;
        if (configResponse?.data?.pub_config && configResponse?.data?.pub_config.length > 0) {
          localStorage.setItem(
            "publisherConfig",
            JSON.stringify(configResponse?.data?.pub_config)
          );
        } else {
          localStorage.setItem(
            "publisherConfig",
            pub_config
          );
        }

        return { channels, firstChannelId, pubConfig };
      })
      .catch((e) => {
        console.error(e);
        return { channels: [], firstChannelId: null, pubConfig: null };
      });

    // Wait for both API calls to complete before navigating to home page
    Promise.all([configDataPromise]).then(([configState]) => {
      const firstChannelId = configState?.firstChannelId || null;
      const channels = configState?.channels || [];
      const pubConfig = configState?.pubConfig || null;

      if (influencer_id) {
        localStorage.setItem("influencer_id", influencer_id);
      }
      if (user_id) {
        localStorage.setItem("user_id", user_id);
      }
      localStorage.setItem("role_id", role_id);
      localStorage.setItem("timezone", timezone);
      localStorage.setItem("currency", JSON.stringify(currency));
      localStorage.setItem("config", JSON.stringify(config));
      localStorage.setItem("routes", JSON.stringify(routes));
      
      localStorage.setItem("user_name", name);
      localStorage.setItem("currentChannel", firstChannelId || "");
      localStorage.setItem("pub_id", pub_id);
      localStorage.setItem("currentPublisher", pub_id);
      localStorage.setItem("user_email", email);
      localStorage.setItem("access-token", access_token)
      localStorage.setItem("isLoged", isLoged);
      localStorage.setItem("isInitialLogin", true);
      localStorage.setItem("bucketType", bucketType);
      localStorage.setItem('sessionStartTime', Date.now());
      localStorage.setItem('pub_user_id', pub_user_id);
      if (contentPartnerId) {
        localStorage.setItem("contentPartnerId", contentPartnerId);
      } else {
        localStorage.removeItem("contentPartnerId");
      }
      if (advertiser_id) {
        localStorage.setItem("advertiser_id", advertiser_id);
      }
      if (isGroupLogin) {
        startGroupSession(groups);
      } else {
        clearGroupSession();
      }

      dispatch(setSessionDetails({
        publisherData: {
          role_id,
          email,
          name,
          bucket_type: bucketType,
          pub_config: pubConfig,
          channels,
          currentChannel: firstChannelId,
          pubid: pub_id,
          timezone,
          currency,
          config
        }
      }));

      // Navigate to home page
      window.location.href = "/";
    });
  };



  const staticValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (!values.email) {
      formIsValid = false;
      errors.email = "Email is required !";
    }
    // else {
    //   if (
    //     values.email &&
    //     !values.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}/)
    //   ) {
    //     formIsValid = false;
    //     errors.email = "Invalid Email";
    //   }
    // }
    if (!values.password) {
      errors.password = "Password required !";
    }
    setErrors(errors);
    return formIsValid;
  };

  useEffect(() => { }, [invalidCredentials]);

  const publisherDetails = async (pubid) => {
    service.getInitials(pubid).then(
      response => {
        if (response.success) {
          response = response.data
          localStorage.setItem("user_name", response?.[0].name);
          localStorage.setItem("user_email", response?.[0].email);
          localStorage.setItem("bucketType", response?.[0].bucket_type);
          return true;
        }
      }
    ).catch(e => {
    })
  }
  // return (
  //   <div fluid className="py-0">
  //     <Row noGutters className="min-vh-100 flex-center">
  //       <Col
  //         lg={5}
  //         className="col-xxl-5 py-3"
  //         style={{ position: "absolute", top: "15vh", left: "29vw" }}
  //       >
  //         <Card className="overflow-hidden z-index-1">
  //           <CardBody>
  //             <img
  //               className="mr-2"
  //               src={logo}
  //               alt="Logo"
  //               style={{
  //                 marginLeft: "30%",
  //                 width: "170px",
  //                 marginBottom: "4px",
  //               }}
  //             />
  //             {/* <img
  //               className="mr-2"
  //               src={logo}
  //               alt="Logo"
  //               style={{ marginLeft: "-35px", width: "250px" }}
  //             /> */}
  //             <Form onSubmit={handleSubmit}>
  //               <FormGroup className="row" style={{ margin: ".5em" }}>
  //                 <Label>Email</Label>
  //                 <Input
  //                   placeholder="Email "
  //                   type="text"
  //                   onChange={({ target }) => {
  //                     hangleChange(target.value, "email");
  //                   }}
  //                 />
  //                 {errors.email && (
  //                   <p style={{ color: "red", fontStyle: "Italic" }}>
  //                     {errors.email}
  //                   </p>
  //                 )}
  //               </FormGroup>

  //               <FormGroup className="row" style={{ margin: ".5em" }}>
  //                 <Label>Password</Label>
  //                 <Input
  //                   placeholder="Password "
  //                   type={passwordShown1 ? "text" : "password"}
  //                   onChange={({ target }) => {
  //                     hangleChange(target.value, "password");
  //                   }}
  //                 />
  //                 {isEye1 && (
  //                   <i
  //                     style={{ marginLeft: "90%", marginTop: "-5vh" }}
  //                     className="eyeIcon"
  //                     onClick={togglePasswordVisiblity1}
  //                   >
  //                     {eye1}
  //                   </i>
  //                 )}
  //                 {errors.password && (
  //                   <p style={{ color: "red", fontStyle: "Italic" }}>
  //                     {errors.password}
  //                   </p>
  //                 )}
  //               </FormGroup>
  //               {/* <FormGroup style={{ textAlign: "end" }}>
  //                                   <Link>
  //                                       Forgot Password?
  //   </Link>
  //                               </FormGroup> */}
  //               <FormGroup>
  //                 <Button
  //                   style={{ width: "100%" }}
  //                   className="btn btn-danger"
  //                   type="submit"
  //                 >
  //                   Log In
  //                 </Button>
  //               </FormGroup>
  //               {invalidCredentials && (
  //                 <p style={{ color: "red", fontStyle: "Italic" }}>
  //                   Invalid Credentials !!
  //                 </p>
  //               )}
  //             </Form>
  //           </CardBody>
  //         </Card>
  //       </Col>
  //     </Row>
  //   </div>
  // );

  // if (ismfaEnable == true) {
  //   return (
  //     <div fluid className="py-0">
  //       <Row noGutters className="min-vh-100 flex-center">
  //         <Col
  //           lg={5}
  //           className="col-xxl-5 py-3"
  //           style={{ position: "absolute", top: "15vh", left: "29vw" }}
  //         >
  //           <Card className="overflow-hidden z-index-1">
  //             <CardBody>
  //               <img
  //                 className="mr-2"
  //                 src={logo}
  //                 alt="Logo"
  //                 style={{
  //                   marginLeft: "30%",
  //                   width: "170px",
  //                   marginBottom: "4px",
  //                 }} />
  //               {/* <p>
  //                       This extra step shows that it's really you trying to sign in
  //                     </p> */}
  //               <Form onSubmit={onSubmitCode}>
  //                 <FormGroup className="row" style={{ margin: ".5em" }}>
  //                   <Label>
  //                     Get a verification code from the Authenticator app
  //                   </Label>
  //                   <Input
  //                     placeholder="Code"
  //                     name="auth_token"
  //                     type="number"
  //                     onChange={({ target }) => {
  //                       onCodeChange(target.value);
  //                     }}
  //                   />
  //                 </FormGroup>
  //                 <FormGroup>
  //                   <Button
  //                     style={{ width: "100%" }}
  //                     className="btn btn-danger"
  //                     type="submit"
  //                   >
  //                     Submit
  //                   </Button>
  //                 </FormGroup>
  //                 {mfaerrorMsg && (
  //                   <p style={{ color: "red", fontStyle: "Italic" }}>
  //                     {mfaerrorMsg}
  //                   </p>
  //                 )}
  //               </Form>
  //             </CardBody>
  //           </Card>
  //         </Col>
  //       </Row>
  //     </div>
  //   );
  // } else {
  if (isChoosingAccount && (isLoadingAccounts || accounts.length > 0 || accountSelectionError)) {
    return (
      <div className="account-selection-screen">
        <div className="account-selection-content">
          <img src={logo} alt="Gizmeon Logo" className="account-selection-logo" />
          <main className="account-selection-panel">
            <h1>Choose an account</h1>
            <p>Select the account you want to continue with.</p>
            {isLoadingAccounts ? (
              <p className="account-picker-subtitle">Loading your available accounts...</p>
            ) : accounts.length > 0 && (
              <div className="account-picker account-selection-list" aria-label="Available accounts">
              {accounts.map((account, index) => (
                <button
                  className="account-option"
                  key={`${account.account_type}-${account.pubid}-${account.publisher_users_id || index}`}
                  type="button"
                  onClick={() => handleAccountSelection(account)}
                  disabled={isSelectingAccount}
                >
                  <span className="account-avatar account-avatar-placeholder" aria-hidden="true">
                    <FaBuilding />
                  </span>
                  <span className="account-option-details">
                    <span className="account-option-name">{account.publisher_name || "Unnamed account"}</span>
                    <span className="account-option-role">{account.role_name || account.account_type}</span>
                  </span>
                  <span className="account-option-arrow" aria-hidden="true">&rsaquo;</span>
                </button>
              ))}
              </div>
            )}
            {accountSelectionError && <p className="account-selection-error">{accountSelectionError}</p>}
            <button className="back-to-login" type="button" onClick={handleBackToCredentials} disabled={isSelectingAccount}>
              Use a different email or password
            </button>
          </main>
        </div>
      </div>
    );
  }

  return (


    <Row noGutters className="custom-login-ui">
      <Col lg={8} className="d-flex align-items-center justify-content-center left-side">
      </Col>
      <Col lg={4} className="right-side">
        <div className="right-side-container">
          <div className="logo-content-wrapper">
            <img src={logo} alt="Gizmeon Logo" className="logo" />
            {/* <p>A complete Video Streaming Platform</p> */}
          </div>

          <div className="login-form-wrapper">
            <div className="login-header">
              <h2>Log in to your account</h2>
            </div>
            {isChoosingAccount && accounts.length > 0 ?
              <div className="account-picker" aria-label="Available accounts">
                {accounts.map((account, index) => (
                  <button
                    className="account-option"
                    key={`${account.account_type}-${account.pubid}-${account.publisher_users_id || index}`}
                    type="button"
                    onClick={() => handleAccountSelection(account)}
                    disabled={isSelectingAccount}
                  >
                    <span className="account-avatar account-avatar-placeholder" aria-hidden="true"><FaBuilding /></span>
                    <span className="account-option-details">
                      <span className="account-option-name">{account.publisher_name || "Unnamed account"}</span>
                      <span className="account-option-role">{account.role_name || account.account_type}</span>
                    </span>
                    <span className="account-option-arrow" aria-hidden="true">›</span>
                  </button>
                ))}
                {accountSelectionError && <p className="account-selection-error">{accountSelectionError}</p>}
                <button className="back-to-login" type="button" onClick={handleBackToCredentials} disabled={isSelectingAccount}>
                  Use a different email or password
                </button>
              </div>
              :
              <>
            <div className="input-fields">
              {
                ismfaEnable ?
                  <Form onSubmit={onSubmitCode}>
                    <FormGroup>
                      <Label className="label-size">
                        Get a verification code from the Authenticator app
                      </Label>
                      <Input
                        className="input-transparent"
                        placeholder="Code"
                        name="auth_token"
                        type="number"
                        onChange={({ target }) => {
                          onCodeChange(target.value);
                        }}
                      />
                    </FormGroup>
                    {mfaerrorMsg && (
                      <p style={{ color: "red", fontStyle: "Italic" }}>
                        {mfaerrorMsg}
                      </p>
                    )}
                  </Form>
                  :
                  <>
                    <FormGroup>
                      <Label for="email">Email</Label>
                      <InputGroup>
                        <Input
                          id="email"
                          type="email"
                          placeholder="Enter your email"
                          value={values.email}
                          onChange={(e) => setValues({ ...values, email: e.target.value })}
                          onFocus={() => handleFocusInput('email')}
                          onBlur={() => handleBlur('email')}
                          className="input-transparent"
                        />
                        <InputGroupAddon addonType="append">
                          <InputGroupText className="input-group-icon">
                            <FaEnvelope color={focused.email ? '#1991ff' : '#ced4da'} />
                          </InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                      {errors.email && (
                        <p style={{ color: "red", fontStyle: "Italic" }}>
                          {errors.email}
                        </p>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <Label for="password">Password</Label>
                      <InputGroup>
                        <Input
                          id="password"
                          type={showPassword ? 'text' : 'password'}
                          placeholder="Enter your password"
                          value={values.password}
                          onChange={(e) => setValues({ ...values, password: e.target.value })}
                          onFocus={() => handleFocusInput('password')}
                          onBlur={() => handleBlur('password')}
                          className="input-transparent"
                        />
                        <InputGroupAddon addonType="append">
                          <InputGroupText className="input-group-icon" onClick={toggleShowPassword}>
                            {showPassword ? <FaEyeSlash  color={focused.password ? '#1991ff' : '#ced4da'}/> : <FaEye  color={focused.password ? '#1991ff' : '#ced4da'}/>}
                          </InputGroupText>
                          {/* <InputGroupText className="input-group-icon">
                            {showPassword ? <FaLock color={focused.password ? '#007bff' : '#ced4da'} /> : <FaEye />}
                          </InputGroupText> */}
                        </InputGroupAddon>
                      </InputGroup>
                      {errors.password && (
                        <p style={{ color: "red", fontStyle: "Italic" }}>
                          {errors.password}
                        </p>
                      )}
                    </FormGroup>
                    {disabledAccountError ? (
                      <p style={{ color: "red", fontStyle: "Italic" }}>
                        {disabledAccountError}
                      </p>
                    ) : invalidCredentials && (
                      <p style={{ color: "red", fontStyle: "Italic" }}>
                        Invalid Credentials !!
                      </p>
                    )}
                    <div className="forgot-password text-right">
                      <Label>
                        <Link to="/pub/forgotPassword">
                          Forgot Password?
                        </Link>
                      </Label>
                    </div>
                  </>
              }
            </div>

            {
              ismfaEnable ?
                <div className="login-button-wrapper">
                  <button className="login-button btn-gradient" onClick={onSubmitCode}>Submit</button>
                </div>
                :
                <div className="login-button-wrapper">
                  <button className="login-button btn-gradient" onClick={handleSubmit}>Log In</button>
                </div>
            }
              </>
            }
          </div>
        </div>
      </Col>
    </Row>


  );

};

export default withRouter(Login);
